import React, { useState } from 'react';
import { Menu, X, ChevronUp } from 'lucide-react';
import ContentSections from '../sections/ContentSections';
import Footer from './Footer';
import Hero from '../sections/Hero';

const Layout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Smooth scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  // Show/hide scroll-to-top button
  React.useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Navigation items array
  const navigationItems = ['About', 'Schedule', 'Workshops', 'Tickets', 'Featured Baterias', 'Merch', 'Samba Memories'];


  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Bar */}
      <nav className="fixed top-0 w-full bg-[#2E0854] text-white z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0">
              <span className="text-xl font-bold">Adelaide Samba Encontro 2025</span>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-8">
              {navigationItems.map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase().replace(' ', '-'))}
                  className="hover:text-[#FFE135] transition-colors duration-200"
                >
                  {item}
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2"
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-[#2E0854]">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigationItems.map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase().replace(' ', '-'))}
                  className="block w-full px-3 py-2 text-white hover:text-[#FFE135]"
                >
                  {item}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Main Content Sections */}
      <main className="pt-16">
        {/* Hero Section */}
        <Hero/>

        {/* Content Sections */}
        <ContentSections />
      </main>

      {/* Footer */}
      <footer className="bg-[#2E0854] text-white py-8">
        <div className="max-w-7xl mx-auto px-4">
          <Footer/>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-8 right-8 bg-[#2E0854] text-white p-3 rounded-full shadow-lg hover:bg-[#FF4500] transition-colors duration-200"
        >
          <ChevronUp size={24} />
        </button>
      )}
    </div>
  );
};

export default Layout;